import { type Dtos, type IncomeStatementId, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { incomeStatementsQueryKey } from "../../financials";

export function useAdminMarkIncomeStatementReviewed(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (incomeStatementId: IncomeStatementId) =>
			post<Dtos.Admin.IncomeStatement.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/income-statements/${incomeStatementId}/review`,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) });
		},
	});

	return {
		reviewIncomeStatement: mutation.mutate,
		reviewISLoading: mutation.isPending,
		reviewISError: mutation.error,
		resetReviewISError: mutation.reset,
	};
}
